import { render, staticRenderFns } from "./ConversationsList.vue?vue&type=template&id=042a1268&"
import script from "./conversations-list.ts?vue&type=script&lang=ts&"
export * from "./conversations-list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports